import type { ImageAspectRatio } from '@tile/components/product-image/types.ts';

export type ImageFormat = 'webp' | 'jpeg';

const IMAGE_BASE_URL = 'https:/*                 */

const IMAGE_QUERY_PARAMS = {
    landscape: {
        jpeg: '$responsive_ftfind_w800$',
        webp: '$responsive_ftfind_w800_webp$',
    },
    default: {
        jpeg: '$responsive_ft2$',
        webp: '$responsive_ft2_webp$',
    },
} as const;

function isLandscapeLayout(aspectRatio?: ImageAspectRatio): boolean {
    /*                                                                     */
    /*                                                                    */
    /*                                                 */
    return aspectRatio === 'landscape';
}

function getQueryParam(format: ImageFormat, aspectRatio?: ImageAspectRatio): string {
    const layoutKey = isLandscapeLayout(aspectRatio) ? 'landscape' : 'default';
    return IMAGE_QUERY_PARAMS[layoutKey][format];
}

export function getImageUrl(id: string, format: ImageFormat, aspectRatio?: ImageAspectRatio): string {
    const queryParam = getQueryParam(format, aspectRatio);
    return `${IMAGE_BASE_URL}${id}?${queryParam}`;
}
